//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapMutations } from "vuex";
export default {
  name: "NaCl",
  data() {
    return {
      form: {
        sex: "0",
        weight: "",
        na: "",
      },
      hasScore: false,
      disabled: false,
 
    };
  },
  created() {
    this.hideLoad();
  },
  methods: {
    ...mapMutations(["hideLoad"]),
  },
  computed: {
    /** 计算公式结果 */
    score() {
      let self = this;
      let form = JSON.parse(JSON.stringify(self.form));
      let flag = true;
      let multiple = 1
      let sumWater = ''
      for (const key in form) {
        if (form.hasOwnProperty(key)) {
          if (!form[key]) {
            flag = false;
          } else {
            if (form[key] == "---") {
              flag = false;
            } else {
              form[key] = Number(form[key]);
            }
          }
        }
      }
      if (!flag) {
        self.hasScore = false;
        return "--";
      } else {
        if(form.sex) {
          multiple = 0.035
        }else {
          multiple = 0.03
        }
        
        let result = ((142 - form.na)*form.weight *multiple).toFixed(2)
        self.hasScore = true;
        return result;
      }
    },
  },
};



// WEBPACK FOOTER //
// ./src/pages/formulas/Common/NaCl.vue